import { ArrowUpRight } from 'lucide-react';
import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { EyebrowLabel } from '@/shared/ui';
import type { QuoteShortcut } from './quote-shortcuts';

interface QuoteShortcutTileProps {
  readonly shortcut: QuoteShortcut;
}

/** 바로가기 한 칸 — 위 가는 선과 각진 판, 누르면 연한 회색으로 바뀐다. 칸 전체가 하나의 링크다. */
export const QuoteShortcutTile = ({ shortcut }: QuoteShortcutTileProps): ReactElement => (
  <li className="border-t border-foreground/15">
    <Link
      to={shortcut.to}
      className="group flex h-full flex-col gap-6 px-1 pt-6 pb-8 transition-colors hover:bg-muted/70 sm:px-5"
    >
      <span className="flex items-center justify-between">
        <EyebrowLabel>{shortcut.eyebrow}</EyebrowLabel>
        <ArrowUpRight
          aria-hidden
          strokeWidth={1.75}
          className="size-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        />
      </span>
      <span className="flex flex-col gap-2">
        <span className="text-xl font-bold tracking-[-0.02em]">{shortcut.title}</span>
        <span className="text-[15px] leading-relaxed text-muted-foreground">
          {shortcut.description}
        </span>
      </span>
    </Link>
  </li>
);
